export default "__VITE_ASSET__CEV6DVTt__"